import { render, staticRenderFns } from "./news4.vue?vue&type=template&id=5adbb5d7&scoped=true&"
import script from "./news4.vue?vue&type=script&lang=js&"
export * from "./news4.vue?vue&type=script&lang=js&"
import style0 from "./news4.vue?vue&type=style&index=0&id=5adbb5d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbb5d7",
  null
  
)

export default component.exports